export default ($) => {
    function init() {
        _setUpListeners();
    }

    function _setUpListeners() {
        $('.dealer-page-link-cookie').click(function() {
            let dealerDid = $(this).attr('data-dealer-id');
            Cookies.set('dealer_did', dealerDid, { expires: 300, path: '/' });
        });
    }

    return {
        init: init
    }
}